/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: inline-block;
  vertical-align: middle;
}
:host .link {
  cursor: pointer;
  text-decoration: none;
}
:host .link .icon {
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  display: inline-block;
  position: relative;
  top: -1px;
}
:host .link .text {
  display: inline-block;
}
:host .link.hasIcon {
  min-height: 1.7142857143rem;
}
:host .link.hasIcon .text {
  margin: 0 0 0 0.5714285714rem;
}
:host .link, :host .link:visited, :host .link:focus {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  color: #007CC1;
  color: var(--davinci-color-primary, #007CC1);
}
:host .link:active {
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
  color: #005B8E;
  color: var(--davinci-color-primary-dark, #005B8E);
}

:host(:hover) .link {
  fill: #009DF4;
  fill: var(--davinci-color-primary-light, #009DF4);
  color: #009DF4;
  color: var(--davinci-color-primary-light, #009DF4);
}

:host(:focus-visible) .link,
:host(:focus) .link {
  outline: none;
}

:host(:not([disabled]):focus-within) {
  outline-color: var(--davinci-color-primary,#007CC1);
  outline-offset: 0.1428571429rem;
  outline-style: solid;
  outline-width: 0.0714285714rem;
}

:host([icon-position=append]) .hasIcon .text {
  margin: 0 0.5714285714rem 0 0;
}

:host([inverted]) {
  background-color: #737F85;
  background-color: var(--davinci-color-secondary, #737F85);
}
:host([inverted]) .hasIcon .text {
  margin: 0 0.5714285714rem;
}
:host([inverted]) .link, :host([inverted]) .link:visited {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary, #FFFFFF);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary, #FFFFFF);
}
:host([inverted]) .link:active {
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFFFFF);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary-light, #FFFFFF);
}

:host([inverted]:hover) {
  background-color: #8E989D;
  background-color: var(--davinci-color-secondary-light, #8E989D);
}
:host([inverted]:hover) .link {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary-light, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-secondary-light, #FFFFFF);
}

:host(:not([icon])) {
  vertical-align: text-top;
}
:host(:not([icon])) .icon {
  display: none;
}

:host([inside-text]) {
  vertical-align: baseline;
}

:host([disabled][inverted]),
:host([disabled]) {
  pointer-events: none;
  cursor: default;
}
:host([disabled][inverted]) .link,
:host([disabled]) .link {
  color: #B1B8BC;
  color: var(--davinci-color-text-disabled, #B1B8BC);
  fill: #B1B8BC;
  fill: var(--davinci-color-text-disabled, #B1B8BC);
}

:host([hidden]) {
  display: none;
}`;
export { style };
